export enum SparePartSupplierType {
  MANUFACTURER = 'Manufacturer',
  SUPPLIER = 'Supplier',
}

export interface SparePartSupplier {
  id: string;
  sellerId: string;
  uniqueName: string;
  addressInfo: {
    addressId: string;
    civility: string;
    firstname: string;
    companyName: string;
    lastname: string;
    address: string;
    additionalAddress: string;
    additionalInformation: string;
    doorCode: string;
    floor: string;
    postalCode: string;
    city: string;
    countryCode: string;
    phone: string;
    isDefault: boolean;
    isValid: boolean;
  };
  website: string;
  connected: boolean;
  sparePartSupplierTypes?: SparePartSupplierType[];
}
